<template>
  <div>
    {{$t("now")}}
  </div>
</template>

<script>
  import { mapState } from "vuex";

  export default {
    name: "Now",
    computed: {
      ...mapState({
        messages: "messages"
      })
    }
  };
</script>
